import { render, staticRenderFns } from "./ClearStorageBtn.vue?vue&type=template&id=6ceb3560&scoped=true&"
import script from "./ClearStorageBtn.vue?vue&type=script&lang=js&"
export * from "./ClearStorageBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb3560",
  null
  
)

export default component.exports